import { v4 as uuidv4 } from "uuid";
import store from "@/store";

/**
 * Get service configuration headers for API requests
 * Adapted for EHR to use the store instead of VA's getValidJwtToken
 */
export async function getServiceConfigHeaders() {
  let headers = {};
  const token = store.getters['login/token'];
  const userId = store.getters['login/userId'];

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (userId) {
    headers["X-User-Id"] = userId;
  }

  // Add x-request-id to header
  let xRequestId = uuidv4();
  headers["X-request-id"] = xRequestId;

  // Note: Sentry configuration removed as EHR may use different error tracking
  return headers;
}
